/* G2 — shared storefront behaviour. Cart runs on Shopify's Cart AJAX API;
   the drawer is re-rendered server-side via bundled section rendering. */
(function(){
  var ROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var SECTION='cart-drawer';
  var open=false, lastFocus=null;

  function byId(id){return document.getElementById(id)}

  function paint(){
    var s=byId('scrim'), d=byId('drawer');
    if(s)s.classList.toggle('on',open);
    if(d){d.classList.toggle('on',open);d.setAttribute('aria-hidden',open?'false':'true')}
    document.documentElement.classList.toggle('cart-open',open);
  }
  function openCart(){
    if(!open){lastFocus=document.activeElement}
    open=true;paint();
    var c=byId('cartClose');if(c)c.focus();
  }
  function closeCart(){
    open=false;paint();
    if(lastFocus&&lastFocus.focus){lastFocus.focus();lastFocus=null}
  }

  function syncCount(){
    var d=byId('drawer'), c=byId('cnt');
    if(d&&c)c.textContent=d.getAttribute('data-count')||'0';
  }

  function swap(html){
    var host=byId('shopify-section-'+SECTION);
    if(!host||!html)return;
    var next=new DOMParser().parseFromString(html,'text/html')
      .getElementById('shopify-section-'+SECTION);
    host.innerHTML=next?next.innerHTML:html;
    paint();syncCount();
  }

  function showError(msg){
    var box=byId('items');if(!box)return;
    var old=box.querySelector('.cart-err');if(old)old.remove();
    var e=document.createElement('div');
    e.className='cart-err';e.setAttribute('role','alert');e.textContent=msg;
    box.insertBefore(e,box.firstChild);
    openCart();
  }

  function post(endpoint,body){
    body.sections=SECTION;
    return fetch(ROOT+endpoint,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(j){return{ok:r.ok,data:j}},function(){return{ok:false,data:{}}});
    });
  }

  function busy(btn,on,label){
    if(!btn)return;
    if(on){
      if(!btn.hasAttribute('data-label'))btn.setAttribute('data-label',btn.textContent.trim());
      btn.disabled=true;btn.textContent=label||'Adding…';
    }else{
      btn.disabled=false;btn.textContent=btn.getAttribute('data-label')||btn.textContent;
    }
  }

  document.addEventListener('submit',function(ev){
    var f=ev.target.closest('form[action*="/cart/add"]');
    if(!f)return;
    ev.preventDefault();
    var btn=f.querySelector('[type=submit]');
    var fd=new FormData(f);
    var id=fd.get('id');
    if(!id){f.submit();return}
    var q=parseInt(fd.get('quantity'),10);
    if(!q||q<1)q=1;
    busy(btn,true);
    post('cart/add.js',{items:[{id:Number(id),quantity:q}]}).then(function(res){
      if(!res.ok){
        busy(btn,false);
        showError(res.data.description||res.data.message||'That could not be added to the cart.');
        return;
      }
      swap(res.data.sections&&res.data.sections[SECTION]);
      busy(btn,false);
      btn.textContent='Added ✓';
      setTimeout(function(){if(btn)btn.textContent=btn.getAttribute('data-label')||'Add to cart'},1200);
      openCart();
    }).catch(function(){busy(btn,false);showError('Network error — please try again.')});
  });

  document.addEventListener('click',function(ev){
    var q=ev.target.closest('[data-line]');
    if(q){
      var line=q.getAttribute('data-line'), qty=Number(q.getAttribute('data-qty'));
      q.disabled=true;
      post('cart/change.js',{id:line,quantity:qty}).then(function(res){
        if(!res.ok){showError(res.data.description||res.data.message||'Could not update the cart.');q.disabled=false;return}
        swap(res.data.sections&&res.data.sections[SECTION]);
      }).catch(function(){q.disabled=false;showError('Network error — please try again.')});
      return;
    }
    if(ev.target.closest('#cartOpen')){openCart();return}
    if(ev.target.closest('#cartClose')){closeCart();return}
    if(ev.target===byId('scrim'))closeCart();
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open)closeCart()});

  window.G2={openCart:openCart,closeCart:closeCart};

  /* Swapping the hero photograph happens from two places now — clicking a
     thumbnail, and choosing a variant that has its own picture. One function,
     so the thumbnail highlight never disagrees with the main image. */
  function showPhoto(src,pos){
    var img=document.getElementById('gimg');
    if(img&&src){
      img.removeAttribute('srcset');
      img.classList.add('swapping');
      var clear=function(){img.classList.remove('swapping')};
      img.onload=clear;img.onerror=clear;setTimeout(clear,400);
      img.src=src;
    }
    if(pos){
      var hit=document.querySelector('.gthumb[data-pos="'+pos+'"]');
      document.querySelectorAll('.gthumb').forEach(function(o){o.classList.toggle('on',o===hit)});
      /* The chosen colour can sit past the fold of a collapsed strip. */
      if(hit&&hit.offsetParent===null){var m=document.getElementById('gmore');if(m)m.click()}
    }
  }

  var vdata=document.getElementById('variantData');
  if(vdata){
    var variants=[];
    try{variants=JSON.parse(vdata.textContent)}catch(e){variants=[]}
    var chosen={};
    document.querySelectorAll('.opt.on').forEach(function(b){chosen[b.getAttribute('data-option')]=b.getAttribute('data-value')});

    function matchVariant(){
      for(var i=0;i<variants.length;i++){
        var v=variants[i],ok=true;
        for(var pos in chosen){if(v.options[pos-1]!==chosen[pos]){ok=false;break}}
        if(ok)return v;
      }
      return null;
    }
    function applyVariant(){
      var v=matchVariant();
      var sel=document.getElementById('variantSelect');
      var price=document.getElementById('priceLabel');
      var sku=document.getElementById('skuLabel');
      var stock=document.getElementById('stockLabel');
      var add=document.getElementById('addBtn');
      if(!v){if(add){add.disabled=true;add.textContent=add.getAttribute('data-out')||'Unavailable'}return}
      if(sel)sel.value=v.id;
      if(price)price.textContent=v.price;
      if(sku)sku.textContent=v.sku||'';
      /* These strings used to be English literals right here, which meant the
         script silently disagreed with the page the moment the shipping promise
         changed — and bypassed the locale file entirely. They come off the
         element now, where Liquid put them. */
      if(stock){
        stock.textContent='';
        if(v.available){
          var dot=document.createElement('span');dot.className='dot';
          stock.appendChild(dot);
          stock.appendChild(document.createTextNode(stock.getAttribute('data-in')||''));
        }else{
          stock.textContent=stock.getAttribute('data-out')||'';
        }
      }
      if(add){add.disabled=!v.available;add.textContent=add.getAttribute(v.available?'data-in':'data-out')||'';add.removeAttribute('data-label')}
      /* 48 products photograph every variant separately — a 26-colour paint
         among them. Show the one being chosen, not whichever came first. */
      if(v.img)showPhoto(v.img,v.pos);
      if(window.history&&history.replaceState){
        var u=new URL(window.location.href);u.searchParams.set('variant',v.id);
        history.replaceState({},'',u.toString());
      }
    }

    document.addEventListener('click',function(ev){
      var b=ev.target.closest('.opt');
      if(b){
        var pos=b.getAttribute('data-option');
        chosen[pos]=b.getAttribute('data-value');
        b.parentNode.querySelectorAll('.opt').forEach(function(o){o.classList.toggle('on',o===b)});
        applyVariant();
        return;
      }
    });

  }

  document.addEventListener('click',function(ev){
    var step=ev.target.closest('#qminus,#qplus');
    if(step){
      var qi=document.getElementById('qtyInput');
      if(!qi)return;
      var n=parseInt(qi.value,10)||1;
      qi.value=step.id==='qplus'?n+1:Math.max(1,n-1);
      return;
    }
    var t=ev.target.closest('.gthumb');
    if(t){showPhoto(t.getAttribute('data-img'),t.getAttribute('data-pos'));return}

    var more=ev.target.closest('#gmore');
    if(more){
      var strip=document.getElementById('gthumbs');
      if(!strip)return;
      var clipped=strip.classList.toggle('gthumbs--clip');
      var label=more.textContent;
      more.textContent=more.getAttribute('data-less');
      more.setAttribute('data-less',label);
      more.setAttribute('aria-expanded',clipped?'false':'true');
    }
  });

  /* Collection browse controls. The markup carried a <noscript> Apply button, so
     auto-submit was always the intent — the script for it was never written, which
     left the whole filter sidebar and the sort dropdown inert. */
  /* The filter panel opens as a disclosure on a phone, where leaving it open
     buried the products a whole screen down. Wide screens keep it open, and
     without JavaScript it stays open everywhere — the old behaviour. */
  var facetPanel=document.getElementById('FacetPanel');
  if(facetPanel&&window.matchMedia){
    var narrow=window.matchMedia('(max-width:900px)');
    var syncPanel=function(m){
      /* Never close it while someone is mid-filter. */
      if(m.matches&&!facetPanel.querySelector(':checked')&&!location.search.match(/filter\./)){
        facetPanel.removeAttribute('open');
      }else if(!m.matches){
        facetPanel.setAttribute('open','');
      }
    };
    syncPanel(narrow);
    if(narrow.addEventListener)narrow.addEventListener('change',syncPanel);
  }

  var facet=document.getElementById('FacetForm');
  if(facet){
    facet.addEventListener('change',function(){
      // Don't send empty price bounds as blank params.
      facet.querySelectorAll('input[type=number]').forEach(function(i){
        if(!i.value)i.disabled=true;
      });
      facet.submit();
    });
  }
  var sortSel=document.getElementById('sortSelect');
  if(sortSel){
    sortSel.addEventListener('change',function(){
      if(sortSel.form)sortSel.form.submit();
    });
  }

  document.querySelectorAll('.card.has-video').forEach(function(card){
    var v=card.querySelector('video');if(!v)return;var loaded=false;
    card.addEventListener('mouseenter',function(){
      if(!loaded){v.src=v.dataset.src;loaded=true}
      var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});
    });
    card.addEventListener('mouseleave',function(){v.pause();v.currentTime=0});
  });

  /* Everything below the hero starts at opacity:0 and waits on this observer,
     so if the observer never runs the homepage is blank from the trust band
     down. That is not hypothetical: a browser suspends IntersectionObserver in
     a background tab, and it was reproduced here with all three .rev blocks
     stuck at opacity 0. The reveal is a nicety; the content is not. A failsafe
     shows anything still hidden after 1.2s, so the worst case is that the
     animation is skipped rather than the page being empty. */
  function revealAll(){
    document.querySelectorAll('.rev:not(.in)').forEach(function(el){el.classList.add('in')});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})
    },{rootMargin:'0px 0px -60px 0px'});
    document.querySelectorAll('.rev').forEach(function(el){io.observe(el)});
    setTimeout(revealAll,1200);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)revealAll()});
  }else{revealAll()}

  syncCount();
})();
